export default {
  title: '商品详情',
  isDisposals: '特卖品',
  productStocknumTag: '库存紧张',
  brandName: '品牌',
  countryOfOrigin: '原产地',
  productNo: '编号',
  productPointNum: '赠送积分',
  couponTags: '优惠券',
  activityTitles: '促销',
  specValueName: '已选规格',
  dispatchInfo: '配送至',
  receiveDate: '最快送达日 {date}',
  transportName: '运输',
  evaluateTitle: '商品评价',
  evaluateAll: '查看全部',
  evaluateAllBottom: '查看全部',
  evaluateNoList: '暂无评论',
  productDesc: '商品描述',
  productNoDesc: '暂无描述哦~~',
  btnProductStatus: '已下架',
  btnInventoryQuantity: '到货通知',
  btnAddCart: '加入购物车',
  proNum: '数量',
  inventoryQuantity: '对不起，该商品暂无库存！',
  mpContent: '请关注{name}微信公众号后留言。',
  mpBtn: '复制公众号名称',
  serverTitle: '客服帮助',
  mycouponTitle: '已领取',
  availableCoupon: '可领取',
  couponType1: '满减券',
  couponType2: '满折券',
  couponType3: '包邮券',
  couponType1UseMoney_text1: '满',
  couponType1UseMoney_text2: '减',
  couponType1NoUseMoney: '任意金额减',
  couponType2UseMoney: '享{discountInfo}%OFF',
  couponType2NoUseMoney: '任意金额享{discountInfo}%OFF',
  couponType3UseMoney: '包邮{discountInfo}',
  couponType3NoUseMoney: '任意金额包邮{discountInfo}',
  freeTransportName: '包邮{freetransportName}',
  couponProductType: '部分商品可用',
  freeTransportType: '{freeTransportAreaName}包邮',
  freeTransportTypeYw: '{freeTransportAreaName}以外包邮',
  receiveNum: '限领{num}张',
  useDate: '有效期',
  dateInterval: '至',
  dateSameDay: '领券当日开始',
  dateNextDay: '领券次日开始',
  valiateDay: '天内有效',
  receive: '领取',
  toUse: '去使用',
  CouponSuccess: '领取成功',
  CollectSuccess: '收藏成功!',
  specsConfirmSuccess: '申请到货通知成功',
  activitTextStart: '距活动开始还有',
  activitTextEnd: '距活动结束还有',
  RelatedList: '相关商品',
  HistoryList: '浏览记录',
  noProduct: '没有找到您想要的商品哦！',
  tips: '系统会根据您的配送地址预估最快送达日。您还可以在结账页面指定收货时间，本服务完全免费。如遇不可抗力因素，如天候，交通状况等有延迟配达可能，还望理解。',
  allcouponProductType: '全部商品可用',
  copySuccess: '复制成功'
};